import { render } from "./TicketsPage.vue?vue&type=template&id=0a7d30c4&scoped=true"
import script from "./TicketsPage.vue?vue&type=script&lang=js"
export * from "./TicketsPage.vue?vue&type=script&lang=js"

import "./TicketsPage.vue?vue&type=style&index=0&id=0a7d30c4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7d30c4"]])

export default __exports__